import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { WarehouseSkuUsageProductResponse } from './warehouse-sku-usage-product.response';
import { WarehouseSkuUsageReceiptResponse } from './warehouse-sku-usage-receipt.response';
import { WarehouseSkuUsageStatus } from '../../enums/warehouse-sku-usage-status';

@jsonObject
export class WarehouseSkuUsageResponse {
  @jsonMember(String)
  public readonly status!: WarehouseSkuUsageStatus;

  @jsonMember(WarehouseSkuUsageProductResponse)
  public readonly good?: WarehouseSkuUsageProductResponse;

  @jsonArrayMember(WarehouseSkuUsageReceiptResponse)
  public readonly receipts?: WarehouseSkuUsageReceiptResponse[];
}
